import { Configuration as AuthConfigOptions } from '@azure/msal-browser';
import AuthConfig from './auth';
import CommonConfig, { CommonConfigOptions } from './common';

export interface ConfigOptions extends CommonConfigOptions {
  auth: AuthConfigOptions;
  recaptchaSiteKey: string;
  appUrl: string;
  graphUrl: string;
  s3Url: string;
  digitalProductSupportUrl: string;
  productSupportUrl: string;
  rosteringSupportUrl: string;
  assessmentAcceleratorVideoUrl: string;
  assessmentAcceleratorPdfUrl: string;
}

const Config: ConfigOptions = {
  ...CommonConfig,
  auth: AuthConfig,
  recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY as string,
  appUrl: process.env.REACT_APP_HOST as string,
  graphUrl: process.env.REACT_APP_GRAPH_URL as string,
  s3Url: process.env.REACT_APP_S3_URL as string,
  digitalProductSupportUrl: process.env.REACT_APP_SUPPORT_URL_DIGITAL_PRODUCT as string,
  productSupportUrl: process.env.REACT_APP_SUPPORT_URL_PRODUCT as string,
  rosteringSupportUrl: process.env.REACT_APP_SUPPORT_URL_ROSTERING as string,
  assessmentAcceleratorVideoUrl: process.env.REACT_APP_ASSESSMENT_ACCELERATOR_VIDEO_URL as string,
  assessmentAcceleratorPdfUrl: process.env.REACT_APP_ASSESSMENT_ACCELERATOR_PDF_URL as string
};

export default Config;
